import { useContext, useEffect, useState } from "react";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import { useParams } from "react-router-dom";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const ReportMasRegionPharmacyCategoryIdPage = () => {
  const [items, setItems] = useState(null);
  const [category, setCategory] = useState(null);
  const [error, setError] = useState(null);
  const params = useParams();

  const { getReportsMasRegionPharmacyCategoryId } = useContext(AdminContext);

  useEffect(() => {
    document.title = "Масы + Регионы + Аптеки";
    getReportsMasRegionPharmacyCategoryId(params.id).then((res) => {
      if (res.status === 200) {
        if (res.data.items.length) {
          setCategory(res.data.category.category);
          setItems(res.data.items);
        } else {
          setError("Нет информации");
        }
      } else {
        setError("Нет информации");
      }
    });
  }, []);

  return (
    <div className="container">
      <ButtonBack shortBtn={true} />

      {!error && !items && !category ? (
        <div style={{ position: "relative", marginTop: 30 }}>
          <CoveredBackground>
            <Loader />
          </CoveredBackground>
        </div>
      ) : error ? (
        <ErrorMessage message={error} />
      ) : (
        <>
          <div className="admin__retake__title">Категория: {category}</div>
          <table className="table_mas_avg_percent">
            <thead>
              <tr>
                <th>МАС</th>
                <th>Средний результат всех аптек </th>
                <th>Регион</th>
                <th>№</th>
                <th>Средний результат аптеки</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, id) => (
                <tr key={id}>
                  <td style={{ fontSize: 20 }}>{item.masName}</td>
                  <td style={{ textAlign: "center" }}>
                    {Number(item.avgTotal).toFixed(2)}
                  </td>
                  <td>{item.region}</td>
                  <td style={{ textAlign: "center" }}>
                    {item.pharmacies.map((ph, id) => (
                      <span key={id}>
                        {ph.numAp}
                        <hr />
                      </span>
                    ))}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {item.pharmacies.map((ph, id) => (
                      <span key={id}>
                        {Number(ph.avgPercent).toFixed(2)}
                        <hr />
                      </span>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>



        </>
      )}
    </div>
  );
};

export default ReportMasRegionPharmacyCategoryIdPage;
